import React from "react";

const ManpowerManagement = () => {
  const manpowerSections = [
    {
      title: "RECRUITMENT AND TRAINING",
      description:
        "A rigorous recruitment process to hire qualified individuals with expertise in online examination management system (OEMS) is followed",
      icon: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z"
            stroke="currentColor"
            strokeWidth="2"
          />
          <path
            d="M12 14C8.13401 14 5 17.134 5 21H19C19 17.134 15.866 14 12 14Z"
            stroke="currentColor"
            strokeWidth="2"
          />
        </svg>
      ),
      color: "#667EEA",
    },
    {
      title: "EXAM COORDINATORS",
      description:
        "We appoint experienced exam coordinators who oversee the entire examination process, including managing exam schedules, coordinating with exam centers across India, and ensuring the smooth execution of online exams",
      icon: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 11H15M9 15H15M17 21L20 18L17 15M7 21L4 18L7 15M12 3V7M8 3H16"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="6"
            y="5"
            width="12"
            height="14"
            rx="2"
            stroke="currentColor"
            strokeWidth="2"
          />
        </svg>
      ),
      color: "#48BB78",
    },
    {
      title: "TECHNICAL SUPPORT TEAM",
      description:
        "The team comprises of skilled professionals who are well-versed in troubleshooting software and hardware issues. They provide prompt assistance to candidates and exam coordinators, ensuring minimal disruption during the exams.",
      icon: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.828 14.828L21 21M16.5 10.5C16.5 14.0899 13.5899 17 10.5 17C7.41015 17 4.5 14.0899 4.5 10.5C4.5 7.41015 7.41015 4.5 10.5 4.5C13.5899 4.5 16.5 7.41015 16.5 10.5Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="10.5"
            cy="10.5"
            r="2"
            stroke="currentColor"
            strokeWidth="2"
          />
        </svg>
      ),
      color: "#ED8936",
    },
    {
      title: "DATA MANAGEMENT EXPERTS",
      description:
        "These experts ensure that the examination results are accurately recorded, securely stored, and readily accessible for further analysis.",
      icon: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 7V4C4 3.44772 4.44772 3 5 3H19C19.5523 3 20 3.44772 20 4V7"
            stroke="currentColor"
            strokeWidth="2"
          />
          <rect
            x="3"
            y="7"
            width="18"
            height="13"
            rx="1"
            stroke="currentColor"
            strokeWidth="2"
          />
          <path
            d="M8 11H16M8 15H13"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      ),
      color: "#9F7AEA",
    },
    {
      title: "QUERY RESOLUTION",
      description:
        "The team ensures that queries from students are addressed promptly. We have established a system to track and prioritize queries based on their urgency.",
      icon: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.5 14.5L12 18L15.5 14.5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 18V6"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="2"
          />
        </svg>
      ),
      color: "#38B2AC",
    },
    {
      title: "CONTINUOUS MONITORING",
      description:
        "We have developed a continuous monitoring system to identify any recurring issues or challenges faced by students. This feedback can be used to improve the query resolution system and address any gaps in the support provided.",
      icon: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="2"
          />
          <polyline
            points="12,6 12,12 16,14"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      color: "#F56565",
    },
  ];

  return (
    <div
      style={{
        background: "white",
        // minHeight: '100vh',
        marginTop: "30px",
        position: "relative",
        // overflow: 'hidden'
      }}
    >
      {/* Background Pattern */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          // backgroundImage: `
          //   radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.3) 0%, transparent 50%),
          //   radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
          //   radial-gradient(circle at 40% 40%, rgba(120, 119, 198, 0.2) 0%, transparent 50%)
          // `,
          pointerEvents: "none",
        }}
      ></div>

      <div
        className="container py-5"
        style={{ position: "relative", zIndex: 1 }}
      >
        {/* Enhanced Heading */}
        <div className="text-center mb-5 title split-collab">
          <div
            style={{
              fontSize: "4rem",
              fontWeight: "500",
              color: "#DC3545",
              marginBottom: "20px",
              letterSpacing: "2px",
              // textShadow: '0 4px 8px rgba(0,0,0,0.3)',
              lineHeight: "1.1",
            }}
          >
            Manpower Management
          </div>
          <div
            style={{
              width: "120px",
              height: "4px",
              background: "linear-gradient(90deg, #ff6b6b, #ee5a24)",
              margin: "0 auto",
              borderRadius: "2px",
              boxShadow: "0 2px 10px rgba(255, 107, 107, 0.4)",
            }}
          ></div>
        </div>

        {/* Main Content Layout */}
        <div className="row align-items-stretch g-5">
          {/* Left Section - Enhanced Images */}
          <div className="col-lg-6">
            <div
              style={{
                background: "rgba(255, 255, 255, 0.1)",
                borderRadius: "25px",
                padding: "30px",
                // backdropFilter: 'blur(20px)',
                // border: '1px solid rgba(255, 255, 255, 0.2)',
                // boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                minHeight: "100%", // Ensure equal height
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              {/* Image 1 */}
              <div
                style={{
                  background: "linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.05) 100%)",
                  borderRadius: "10px",
                  height: "280px",
                  marginBottom: "25px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "2px dashed rgba(255,255,255,0.3)",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.02)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 30px rgba(0,0,0,0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div className="text-center">
                  <div
                    style={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 15px",
                      border: "2px solid rgba(255,255,255,0.3)",
                      width: "100%",
                      height: "100%",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src="../assets/images/MANPOWER_MANAGEMENT/Picture1.png"
                      alt="Training"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <p
                    style={{
                      color: "white",
                      fontSize: "16px",
                      fontWeight: "600",
                      margin: 0,
                      opacity: 0.9,
                    }}
                  >
                    Training Session Image
                  </p>
                </div>
              </div>

              {/* Image 2 */}
              <div
                style={{
                  background:
                    "linear-gradient(135deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.05) 100%)",
                  borderRadius: "10px",
                  height: "280px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "2px dashed rgba(255,255,255,0.3)",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.02)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 30px rgba(0,0,0,0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div className="text-center">
                  <div
                     style={{
                      background: "rgba(255,255,255,0.2)",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 15px",
                      border: "2px solid rgba(255,255,255,0.3)",
                      width: "100%",
                      height: "100%",
                      overflow: "hidden",
                    }}
                  >
                     <img
                      src="../assets/images/MANPOWER_MANAGEMENT/Picture2.png"
                      alt="Training"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <p
                    style={{
                      color: "white",
                      fontSize: "16px",
                      fontWeight: "600",
                      margin: 0,
                      opacity: 0.9,
                    }}
                  >
                    Team Excellence Image
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Section - Enhanced Content */}
          <div className="col-lg-6">
            <div
              style={{
                borderRadius: "25px",
                padding: "40px",
                // backdropFilter: 'blur(20px)',
                // border: '1px solid rgba(255, 255, 255, 0.3)',
                // boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                minHeight: "100%", // Ensure equal height
                display: "block", // Reset to block for grid
              }}
            >
              <div className="row row-cols-1 row-cols-md-2 g-4">
                {manpowerSections.map((section, index) => (
                  <div key={index} className="col">
                    <div
                      style={{
                        padding: "15px",
                        background: `linear-gradient(135deg, ${section.color}15 0%, ${section.color}05 100%)`,
                        borderRadius: "15px",
                        border: `2px solid ${section.color}20`,
                        transition: "all 0.3s ease",
                        cursor: "pointer",
                        minHeight: "200px", // Fixed height to maintain uniformity
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateX(5px)";
                        e.currentTarget.style.boxShadow = `0 10px 25px ${section.color}20`;
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateX(0)";
                        e.currentTarget.style.boxShadow = "none";
                      }}
                    >
                      <div className="d-flex align-items-start h-100">
                        <div
                          style={{
                            width: "40px",
                            height: "50px",
                            background: `linear-gradient(135deg, ${section.color} 0%, ${section.color}CC 100%)`,
                            borderRadius: "15px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: "10px",
                            flexShrink: 0,
                            color: "white",
                            boxShadow: `0 8px 20px ${section.color}40`,
                          }}
                        >
                          {section.icon}
                        </div>
                        <div style={{ flex: 1 }}>
                          <h5
                            style={{
                              color: section.color,
                              fontSize: "14px",
                              fontWeight: "700",
                              marginBottom: "10px",
                              letterSpacing: "0.5px",
                            }}
                          >
                            {section.title}
                          </h5>
                          <p
                            style={{
                              color: "black",
                              fontSize: "12px",
                              fontWeight: "500",
                              lineHeight: "1.4",
                              margin: 0,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              WebkitLineClamp: "3",
                              WebkitBoxOrient: "vertical",
                            }}
                          >
                            {section.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Enhanced Footer */}
        <div className="text-center mt-5">
          <div
            style={{
              background: "rgba(255, 255, 255, 0.1)",
              borderRadius: "20px",
              padding: "30px",
              backdropFilter: "blur(20px)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
              maxWidth: "800px",
              margin: "0 auto",
            }}
          >
            <div
              style={{
                fontSize: "20px",
                fontStyle: "italic",
                fontWeight: "600",
                background: "linear-gradient(45deg, #ff6b6b, #ee5a24)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                lineHeight: "1.4",
                textShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              "We also assists other authorized agencies in conducting various
              examinations across India"
            </div>
            <div
              style={{
                width: "60px",
                height: "3px",
                background: "linear-gradient(90deg, #ff6b6b, #ee5a24)",
                margin: "20px auto 0",
                borderRadius: "2px",
              }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManpowerManagement;
